import { useCallback, useRef } from "react";
import {
  buildSessionUpdatePayload,
  buildTrainingSessionUpdatePayload,
} from "@teleprompt/shared/realtime";
import { normalizeMeetingForRealtime } from "./realtimeMeetingAdapter";

/**
 * Applies canonical realtime instructions from @teleprompt/shared.
 * Web keeps only session plumbing here; instruction and tool contracts live in shared.
 */
export default function useMeetingInstructions({ trainingSession }) {
  const instructionsSentRef = useRef(false);

  const resetInstructions = useCallback(() => {
    instructionsSentRef.current = false;
  }, []);

  const applyInstructions = useCallback(
    ({ meetingData, priorConvoRef, voiceId, sendEvent, force = false }) => {
      if (!meetingData) return false;
      if (instructionsSentRef.current && !force) return true;
      if (typeof sendEvent !== "function") {
        console.warn("[applyInstructions] sendEvent not ready");
        return false;
      }

      const realtimeMeeting = normalizeMeetingForRealtime(meetingData, voiceId);
      const conversation = Array.isArray(priorConvoRef?.current) ? priorConvoRef.current : [];
      const sessionPayload = trainingSession
        ? buildTrainingSessionUpdatePayload(realtimeMeeting, trainingSession, conversation, {
            pushToTalk: true,
          })
        : buildSessionUpdatePayload(realtimeMeeting, conversation);

      sendEvent({
        type: "session.update",
        session: sessionPayload,
      });

      instructionsSentRef.current = true;
      return true;
    },
    [trainingSession]
  );

  return { applyInstructions, instructionsSentRef, resetInstructions };
}
